import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAssetViewerContext } from 'screens/AssetViewerUI/hooks/useAssetViewerContext';
function Download(_ref) {
  var Component = _ref.as;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAssetViewerContex = useAssetViewerContext(),
    downloadUrl = _useAssetViewerContex.downloadUrl;
  return /*#__PURE__*/React.createElement(Component, {
    icon: "download",
    as: "a",
    href: downloadUrl
  }, t('actions_download'));
}
export default Download;